import { purgeRegisteredStores } from '@app/core/stores';
import { useAuth0 } from '@auth0/auth0-react';
import debugFn from 'debug';
import { usePostHog } from 'posthog-js/react';
import { useImpersonation } from '../../impersonation';

const debug = debugFn('LogoutPage');

export function useLogout() {
  const { clearAll } = useImpersonation();
  const { logout } = useAuth0();

  const posthog = usePostHog();

  return ({ returnTo }: { returnTo?: string } = {}) => {
    debug('Logging out');

    clearAll();
    purgeRegisteredStores();
    posthog?.reset();

    logout({
      logoutParams: {
        returnTo: encodeURI(window.location.origin + (returnTo ?? '')),
      },
    });
  };
}
